module.exports = __webpack_public_path__ + "img/folder.1780522e.png";